import React from "react";
import { Route, Routes } from "react-router-dom";
import { routerLists } from "./route.js";

const RouterWrapper = () => {
  const routeList = routerLists.map((el) => {
    if (el.children) {
      return (
        <Route element={el.element} path={el.path} key={el.id}>
          {el.children.map((child) => (
            <Route key={child.id} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return <Route element={el.element} path={el.path} key={el.id} />;
  });
  return <Routes>{routeList}</Routes>;
};

export default RouterWrapper;
